import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Pictogram } from '@sola/ark-core/atoms/pictogram/pictogram.tsx';
import { getWriteBaseUrl, getWriteCommunicationsUrl } from '@sola/my-sdk/constants.ts';
import type { GraphQLLetter } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
import { usePrimaryCtaLetterRead } from './primary-cta-letter-read.logic.ts';
export const PrimaryCtaLetterRead: React.FC<{
  latestLetterPerChild: GraphQLLetter[];
}> = t0 => {
  const $ = _c(22);
  const {
    latestLetterPerChild
  } = t0;
  let t1;
  if ($[0] !== latestLetterPerChild) {
    t1 = {
      letters: latestLetterPerChild
    };
    $[0] = latestLetterPerChild;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t,
    count,
    title,
    subtitle
  } = usePrimaryCtaLetterRead(t1);
  if (!latestLetterPerChild || latestLetterPerChild.length === 0) {
    return null;
  }
  let t2;
  if ($[2] !== latestLetterPerChild[0] || $[3] !== latestLetterPerChild.length) {
    t2 = latestLetterPerChild.length === 1 ? getWriteCommunicationsUrl(latestLetterPerChild[0].id) : getWriteBaseUrl();
    $[2] = latestLetterPerChild[0];
    $[3] = latestLetterPerChild.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const link = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PrimaryCtaIcon><Pictogram name="letter" /></PrimaryCtaIcon>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== subtitle) {
    t5 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[8] = subtitle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <PrimaryCtaBody>{t4}{t5}</PrimaryCtaBody>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== count || $[14] !== t) {
    t7 = t("my:primaryCtaLetterRead.cta", {
      count
    });
    $[13] = count;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== link || $[17] !== t7) {
    t8 = <PrimaryCtaActions><ButtonStyle variant="secondary"><a href={link}>{t7}</a></ButtonStyle></PrimaryCtaActions>;
    $[16] = link;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <PrimaryCta variant="default">{t3}{t6}{t8}</PrimaryCta>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};